import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { OptionsColor } from "../OptionsColor";
export var BackgroundMaskCover = /*#__PURE__*/function () {
  function BackgroundMaskCover() {
    _classCallCheck(this, BackgroundMaskCover);
    this.color = new OptionsColor();
    this.opacity = 1;
  }
  _createClass(BackgroundMaskCover, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      if (data.color !== undefined) {
        this.color = OptionsColor.create(this.color, data.color);
      }
      if (data.opacity !== undefined) {
        this.opacity = data.opacity;
      }
    }
  }]);
  return BackgroundMaskCover;
}();